.canvas {
    background: #333;
    image-rendering: pixelated;
}
